export const SITE_URL = "https://cresci.kids";
export const SITE_NAME = "Cresci";
export const SIGNUP_URL = "https://app.cresci.kids/auth/signup";
export const OG_IMAGE_PATH = "/og-image.png";
export const OG_IMAGE_URL = `${SITE_URL}${OG_IMAGE_PATH}`;

import type { Locale } from "./routes-manifest";

export const OG_LOCALE: Record<Locale, string> = {
  en: "en_US",
  it: "it_IT",
  fr: "fr_FR",
  de: "de_DE",
  es: "es_ES",
  pl: "pl_PL",
  sr: "sr_RS",
};

export function absoluteUrl(path: string): string {
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  if (path === "/") return `${SITE_URL}/`;
  return `${SITE_URL}${path}`;
}
